import { render, staticRenderFns } from "./goToHandlePage.vue?vue&type=template&id=9735558e&scoped=true"
import script from "./goToHandlePage.vue?vue&type=script&lang=js"
export * from "./goToHandlePage.vue?vue&type=script&lang=js"
import style0 from "./goToHandlePage.vue?vue&type=style&index=0&id=9735558e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9735558e",
  null
  
)

export default component.exports